import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { WideLayout } from '../../../shared/layout/widelayout';
import { useLayoutStore } from '../../../stores/portalStore';
import { usePatientsStore } from '../../patients/store/patientsStore';
import { useSalesStore } from '../store/salesStore';
import { useSuballocationStore } from '../store/suballocationStore';
import { PatientsList } from '../../patients/usecases/legacy/list';
import { unformatCPF } from '../../../utils/format';
import { useResponsive } from '../../../hooks/useResponsive';

const ProductOrderPatientPanels = ({ storeHook, title, catalogPath }) => {
  const selectedPatient = storeHook((state) => state.selectedPatient);
  const setSelectedPatient = storeHook((state) => state.setSelectedPatient);
  const patients = usePatientsStore((state) => state.patients);
  const contentWidth = useLayoutStore((state) => state.contentWidth);
  const { isDesktop } = useResponsive();
  const navigate = useNavigate();

  const onRowSelected = (row, index) => {
    const patient = Number.isInteger(index)
      ? patients[index]
      : patients.find(
          (item) => unformatCPF(item.cpf) === unformatCPF(row?.[1])
        );
    setSelectedPatient(patient ?? null);
  };

  return (
    <div
      style={{
        maxWidth: isDesktop && contentWidth ? contentWidth : '100%',
        margin: '15px',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '16px',
      }}
    >
      <PatientsList
        title={title}
        subtitle=""
        topSearchRight={true}
        onlyActives={false}
        readOnly={true}
        header={['Nome', 'CPF', 'Empresa', 'CNPJ', 'Endereço']}
        fields={['name', 'cpf', 'company', 'cnpj', 'address']}
        height={window.innerHeight - 400 + 'px'}
        onRowSelected={onRowSelected}
        disableSearchWhileLoading={true}
        resetSearchOnMount={true}
        useOrderFlowTable={true}
        manualSearch={true}
        newClientAction={
          <PrimaryButton
            disabled={!selectedPatient}
            onClick={() => navigate(catalogPath)}
          >
            Prosseguir para catálogo
          </PrimaryButton>
        }
      />
    </div>
  );
};

const ProductOrderSelectPatientPage = ({
  storeHook,
  title,
  selectPath,
  catalogPath,
}) => {
  const selectedPatient = storeHook((state) => state.selectedPatient);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedPatient === undefined) navigate(selectPath);
  }, [navigate, selectPath, selectedPatient]);

  return (
    <WideLayout
      outlet={
        <ProductOrderPatientPanels
          storeHook={storeHook}
          title={title}
          catalogPath={catalogPath}
        />
      }
    />
  );
};

export const SalesSelectPatientPage = () => (
  <ProductOrderSelectPatientPage
    storeHook={useSalesStore}
    title="Descartáveis"
    selectPath="/order/newOrder"
    catalogPath="/sales/catalog"
  />
);

export const SuballocationSelectPatientPage = () => (
  <ProductOrderSelectPatientPage
    storeHook={useSuballocationStore}
    title="Sublocação"
    selectPath="/order/newOrder"
    catalogPath="/suballocation/catalog"
  />
);
